export enum CatalogRoutesPathEnum {
    CATALOG_OFFER_LIST = '',
    CATALOG_OFFER = ':categoryId',
}
